// @ts-nocheck
// «Οικονομικά Σκαφών» — ΒΗΜΑ 1: ιεραρχική πλοήγηση (λιτό, ίδια γλώσσα με τα tabs ΛΟΓΙΣΤΙΚΩΝ).
// ΠΑΝΩ: ψαχτήρι full-width + έτος. ΜΠΑΡΑ εταιριών (δυναμικά) → 2η μπάρα με σκάφη+Γενικά.
// IKE (χωρίς σκάφη) & Αταξινόμητα → κατευθείαν σελίδα. Σκάφη χωρίς εταιρία → ομάδα «Χωρίς εταιρία».
// Σελίδες προορισμού = placeholder (Βήμα 2/3). Counts server-side στο financials.php.
import React, { useState, useEffect, useRef } from 'react';
import authService from './authService';

const FinancialsSelect: React.FC = () => {
  const user = authService.getCurrentUser();
  const code = user?.code || '';

  const [year, setYear] = useState<string>('2026');
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [q, setQ] = useState<string>('');
  const [results, setResults] = useState<any[]>([]);
  const [openCompany, setOpenCompany] = useState<string>(''); // code | 'UNASSIGNED'
  const [page, setPage] = useState<any>(null);                // {label} placeholder

  const api = (qs: string) => fetch('/api/financials.php' + qs, { headers: { 'X-Employee-Code': code } });

  const loadOverview = async () => {
    setLoading(true);
    try {
      const r = await api('?action=overview&year=' + encodeURIComponent(year));
      const j = await r.json();
      if (r.ok) setData(j);
    } catch (e) { /* ignore */ }
    finally { setLoading(false); }
  };
  useEffect(() => { loadOverview(); setOpenCompany(''); setPage(null); /* eslint-disable-next-line */ }, [year]);

  const timer = useRef<any>(null);
  useEffect(() => {
    if (timer.current) clearTimeout(timer.current);
    if (!q.trim()) { setResults([]); return; }
    timer.current = setTimeout(async () => {
      try { const r = await api('?action=search&q=' + encodeURIComponent(q.trim())); const j = await r.json(); setResults(j.results || []); }
      catch (e) { /* ignore */ }
    }, 350);
    return () => timer.current && clearTimeout(timer.current);
    /* eslint-disable-next-line */
  }, [q]);

  const money = (n: any) => Number(n || 0).toLocaleString('el-GR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  if (!data) return <div style={{ padding: 20, color: '#888' }}>{loading ? 'Φόρτωση…' : '—'}</div>;

  const vessels = data.vessels || [];
  const entities = data.entities || [];
  const vesselsOf = (c: string) => vessels.filter((v: any) => v.entity === c);
  const unassigned = vessels.filter((v: any) => !v.entity);
  const entPending = (c: string) => (entities.find((e: any) => e.code === c)?.pending || 0);
  const companyTotal = (c: string) => entPending(c) + vesselsOf(c).reduce((s: number, v: any) => s + (v.pending || 0), 0);
  const unassignedTotal = unassigned.reduce((s: number, v: any) => s + (v.pending || 0), 0);

  const openPage = (label: string) => setPage({ label });

  // click σε στοιχείο μπάρας εταιριών
  const clickCompany = (kind: string, codeOrKey: string, label: string) => {
    setPage(null);
    if (kind === 'entity') {
      if (vesselsOf(codeOrKey).length > 0) setOpenCompany(openCompany === codeOrKey ? '' : codeOrKey);
      else { setOpenCompany(''); openPage(label); }           // IKE χωρίς σκάφη → σελίδα
    } else if (kind === 'unassigned') {
      setOpenCompany(openCompany === 'UNASSIGNED' ? '' : 'UNASSIGNED');
    } else if (kind === 'unclassified') {
      setOpenCompany(''); openPage('Αταξινόμητα');
    }
  };

  // ---- styles (λιτά, ίδια γλώσσα με τα tabs ΛΟΓΙΣΤΙΚΩΝ) ----
  const barWrap: any = { display: 'flex', gap: 8, overflowX: 'auto', paddingBottom: 6, WebkitOverflowScrolling: 'touch' };
  const tabBtn = (active: boolean): any => ({
    display: 'inline-flex', alignItems: 'center', gap: 8, flexShrink: 0, padding: '9px 16px', cursor: 'pointer',
    border: '1px solid ' + (active ? '#1976d2' : '#d5dbe1'), background: active ? '#1976d2' : '#fff',
    color: active ? '#fff' : '#333', borderRadius: 8, fontSize: 14, fontWeight: active ? 700 : 500, whiteSpace: 'nowrap',
  });
  const badge = (n: number, active: boolean): any => ({
    minWidth: 20, padding: '1px 7px', borderRadius: 10, fontSize: 12, fontWeight: 800, textAlign: 'center',
    background: active ? 'rgba(255,255,255,0.25)' : (n > 0 ? '#fff3e0' : '#eef1f4'),
    color: active ? '#fff' : (n > 0 ? '#b26a00' : '#9aa4ad'),
  });

  const isPageVessel = (label: string) => page && page.label === label;

  return (
    <div style={{ maxWidth: 1100, margin: '0 auto' }}>
      <h2 style={{ marginTop: 0, fontSize: 22 }}>Οικονομικά Σκαφών</h2>

      {/* 1. ψαχτήρι full-width + έτος */}
      <div style={{ display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap', marginBottom: 8 }}>
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="🔎 Αναζήτηση ΑΦΜ / προμηθευτή…"
          style={{ flex: '1 1 320px', minWidth: 0, padding: '10px 14px', borderRadius: 8, border: '1px solid #ccc', fontSize: 15, boxSizing: 'border-box' }} />
        <select value={year} onChange={(e) => setYear(e.target.value)}
          style={{ padding: '10px 12px', borderRadius: 8, border: '1px solid #ccc', fontSize: 15 }}>
          <option value="2026">2026</option>
          <option value="2025">2025</option>
          <option value="all">Όλα</option>
        </select>
      </div>

      {/* search results */}
      {results.length > 0 && (
        <div style={{ background: '#fff', border: '1px solid #e3e8ee', borderRadius: 10, padding: 8, marginBottom: 14, maxHeight: 280, overflowY: 'auto' }}>
          {results.map((r, i) => (
            <div key={r.source + r.id + i} style={{ display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap', padding: '7px 8px', borderBottom: '1px solid #f2f4f6', fontSize: 13 }}>
              <span style={{ color: '#8a94a0', minWidth: 54 }}>{r.source === 'invoice' ? 'Τιμ.' : 'Τράπ.'}</span>
              <span style={{ fontFamily: 'monospace', color: '#666', minWidth: 84 }}>{r.date || '—'}</span>
              <span style={{ fontWeight: 700, minWidth: 90, textAlign: 'right' }}>€{money(r.amount)}</span>
              <span style={{ flex: '1 1 220px' }}>{r.vendor || '—'}</span>
              <span style={{ color: '#888' }}>{r.afm || ''}</span>
              {r.vessel && <span style={{ background: '#eef6ff', color: '#1565c0', padding: '1px 7px', borderRadius: 8 }}>{r.vessel}</span>}
              {r.entity && <span style={{ background: '#f3e9fb', color: '#7b1fa2', padding: '1px 7px', borderRadius: 8 }}>{r.entity}</span>}
              {r.possible_dup && <span title="πιθανό διπλό" style={{ color: '#c62828' }}>⚠</span>}
            </div>
          ))}
        </div>
      )}

      {/* 2. μπάρα εταιριών (δυναμικά) */}
      <div style={barWrap}>
        {entities.map((e: any) => {
          const active = openCompany === e.code || (page && page.label === e.name);
          return (
            <button key={e.code} style={tabBtn(active)} onClick={() => clickCompany('entity', e.code, e.name)}>
              {e.code}<span style={badge(companyTotal(e.code), active)}>{companyTotal(e.code)}</span>
            </button>
          );
        })}
        {unassigned.length > 0 && (
          <button style={tabBtn(openCompany === 'UNASSIGNED')} onClick={() => clickCompany('unassigned', 'UNASSIGNED', 'Χωρίς εταιρία')}>
            Χωρίς εταιρία<span style={badge(unassignedTotal, openCompany === 'UNASSIGNED')}>{unassignedTotal}</span>
          </button>
        )}
        <button style={tabBtn(page && page.label === 'Αταξινόμητα')} onClick={() => clickCompany('unclassified', '', 'Αταξινόμητα')}>
          📥 Αταξινόμητα<span style={badge(data.unclassified, page && page.label === 'Αταξινόμητα')}>{data.unclassified}</span>
        </button>
      </div>

      {/* 3. 2η μπάρα: σκάφη της εταιρίας + Γενικά */}
      {(openCompany && (openCompany === 'UNASSIGNED' || vesselsOf(openCompany).length > 0)) && (
        <div style={{ ...barWrap, marginTop: 4, paddingLeft: 4, borderLeft: '3px solid #1976d2' }}>
          {(openCompany === 'UNASSIGNED' ? unassigned : vesselsOf(openCompany)).map((v: any) => (
            <button key={v.id} style={tabBtn(isPageVessel(v.name))} onClick={() => openPage(v.name)}>
              {v.name}<span style={badge(v.pending, isPageVessel(v.name))}>{v.pending}</span>
            </button>
          ))}
          {openCompany !== 'UNASSIGNED' && (
            <button style={tabBtn(isPageVessel('Γενικά — ' + openCompany))} onClick={() => openPage('Γενικά — ' + openCompany)}>
              Γενικά (εταιρία)<span style={badge(entPending(openCompany), isPageVessel('Γενικά — ' + openCompany))}>{entPending(openCompany)}</span>
            </button>
          )}
        </div>
      )}

      {/* 4. σελίδα προορισμού (placeholder) */}
      {page && (
        <div style={{ marginTop: 20, padding: 24, background: '#f8fafc', border: '1px solid #e3e8ee', borderRadius: 10 }}>
          <div style={{ fontSize: 16, fontWeight: 700, marginBottom: 6 }}>{page.label}</div>
          <div style={{ color: '#667', fontSize: 14 }}>Η σελίδα έρχεται (Βήμα 2/3): σύνολα Έσοδα−Έξοδα−Καθαρό, εκκρεμή, καταχωρημένα, προς πληρωμή, μηνιαίοι πίνακες.</div>
        </div>
      )}

      {!page && !openCompany && <p style={{ color: '#8a94a0', marginTop: 18, fontSize: 14 }}>Επίλεξε εταιρία από τη μπάρα για να δεις τα σκάφη της.</p>}
    </div>
  );
};

export default FinancialsSelect;
